export default __webpack_public_path__ + "static/media/logo.5b6e5d59.png";